import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { SyntheticPlatformEmitter } from '@unimodules/core';

function getStatusFromMedia(media) {
  if (!media) {
    return {
      isLoaded: false,
      error: undefined
    };
  }

  var isPlaying = !!(media.currentTime > 0 && !media.paused && !media.ended && media.readyState > 2);
  var status = {
    isLoaded: true,
    uri: media.src,
    progressUpdateIntervalMillis: 100,
    durationMillis: media.duration * 1000,
    positionMillis: media.currentTime * 1000,
    shouldPlay: media.autoplay,
    isPlaying: isPlaying,
    isBuffering: false,
    rate: media.playbackRate,
    shouldCorrectPitch: false,
    volume: media.volume,
    isMuted: media.muted,
    isLooping: media.loop,
    didJustFinish: media.ended
  };
  return status;
}

function setStatusForMedia(media, status) {
  if (status.positionMillis !== undefined) {
    media.currentTime = status.positionMillis / 1000;
  }

  if (status.shouldPlay !== undefined) {
    if (status.shouldPlay) {
      media.play();
    } else {
      media.pause();
    }
  }

  if (status.rate !== undefined) {
    media.playbackRate = status.rate;
  }

  if (status.volume !== undefined) {
    media.volume = status.volume;
  }

  if (status.isMuted !== undefined) {
    media.muted = status.isMuted;
  }

  if (status.isLooping !== undefined) {
    media.loop = status.isLooping;
  }

  return getStatusFromMedia(media);
}

export default {
  get name() {
    return 'ExponentAV';
  },

  getStatusForVideo: function getStatusForVideo(element) {
    return _regeneratorRuntime.async(function getStatusForVideo$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", getStatusFromMedia(element));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, null, null, null, Promise);
  },
  loadForVideo: function loadForVideo(element, nativeSource, fullInitialStatus) {
    return _regeneratorRuntime.async(function loadForVideo$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", getStatusFromMedia(element));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, null, null, null, Promise);
  },
  unloadForVideo: function unloadForVideo(element) {
    return _regeneratorRuntime.async(function unloadForVideo$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", getStatusFromMedia(element));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, null, null, null, Promise);
  },
  setStatusForVideo: function setStatusForVideo(element, status) {
    return _regeneratorRuntime.async(function setStatusForVideo$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", setStatusForMedia(element, status));

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, null, null, null, Promise);
  },
  replayVideo: function replayVideo(element, status) {
    return _regeneratorRuntime.async(function replayVideo$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", setStatusForMedia(element, status));

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, null, null, null, Promise);
  },
  setAudioMode: function setAudioMode() {
    return _regeneratorRuntime.async(function setAudioMode$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
          case "end":
            return _context6.stop();
        }
      }
    }, null, null, null, Promise);
  },
  setAudioIsEnabled: function setAudioIsEnabled() {
    return _regeneratorRuntime.async(function setAudioIsEnabled$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
          case "end":
            return _context7.stop();
        }
      }
    }, null, null, null, Promise);
  },
  getStatusForSound: function getStatusForSound(element) {
    return _regeneratorRuntime.async(function getStatusForSound$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt("return", getStatusFromMedia(element));

          case 1:
          case "end":
            return _context8.stop();
        }
      }
    }, null, null, null, Promise);
  },
  loadForSound: function loadForSound(nativeSource, fullInitialStatus) {
    var source, media, status;
    return _regeneratorRuntime.async(function loadForSound$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            source = typeof nativeSource === 'string' ? nativeSource : nativeSource.uri;
            media = new Audio(source);

            media.ontimeupdate = function () {
              SyntheticPlatformEmitter.emit('didUpdatePlaybackStatus', {
                key: media,
                status: getStatusFromMedia(media)
              });
            };

            media.onerror = function () {
              SyntheticPlatformEmitter.emit('ExponentAV.onError', {
                key: media,
                error: media.error.message
              });
            };

            status = setStatusForMedia(media, fullInitialStatus);
            return _context9.abrupt("return", [media, status]);

          case 6:
          case "end":
            return _context9.stop();
        }
      }
    }, null, null, null, Promise);
  },
  unloadForSound: function unloadForSound(element) {
    return _regeneratorRuntime.async(function unloadForSound$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            element.pause();
            element.removeAttribute('src');
            element.load();
            return _context10.abrupt("return", getStatusFromMedia(element));

          case 4:
          case "end":
            return _context10.stop();
        }
      }
    }, null, null, null, Promise);
  },
  setStatusForSound: function setStatusForSound(element, status) {
    return _regeneratorRuntime.async(function setStatusForSound$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            return _context11.abrupt("return", setStatusForMedia(element, status));

          case 1:
          case "end":
            return _context11.stop();
        }
      }
    }, null, null, null, Promise);
  },
  replaySound: function replaySound(element, status) {
    return _regeneratorRuntime.async(function replaySound$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            return _context12.abrupt("return", setStatusForMedia(element, status));

          case 1:
          case "end":
            return _context12.stop();
        }
      }
    }, null, null, null, Promise);
  },
  getAudioRecordingStatus: function getAudioRecordingStatus() {
    return _regeneratorRuntime.async(function getAudioRecordingStatus$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
          case "end":
            return _context13.stop();
        }
      }
    }, null, null, null, Promise);
  },
  prepareAudioRecorder: function prepareAudioRecorder() {
    return _regeneratorRuntime.async(function prepareAudioRecorder$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
          case "end":
            return _context14.stop();
        }
      }
    }, null, null, null, Promise);
  },
  startAudioRecording: function startAudioRecording() {
    return _regeneratorRuntime.async(function startAudioRecording$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
          case "end":
            return _context15.stop();
        }
      }
    }, null, null, null, Promise);
  },
  pauseAudioRecording: function pauseAudioRecording() {
    return _regeneratorRuntime.async(function pauseAudioRecording$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
          case "end":
            return _context16.stop();
        }
      }
    }, null, null, null, Promise);
  },
  stopAudioRecording: function stopAudioRecording() {
    return _regeneratorRuntime.async(function stopAudioRecording$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
          case "end":
            return _context17.stop();
        }
      }
    }, null, null, null, Promise);
  },
  unloadAudioRecorder: function unloadAudioRecorder() {
    return _regeneratorRuntime.async(function unloadAudioRecorder$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
          case "end":
            return _context18.stop();
        }
      }
    }, null, null, null, Promise);
  }
};